// Раздел «Рынок» (цены рыбы). Признак кабинета `market_prices` закрывает его
// на сервере отказом с кодом; витрина показывает отказ, а не «Ошибку загрузки».

import { ApiError } from '../api'
import { parseErrorDetail } from '../i18n/apiLabels'

export function isPricesForbidden(error: unknown): boolean {
  if (!(error instanceof ApiError) || error.status !== 403) return false
  return parseErrorDetail(error.detail)?.code === 'prices_forbidden'
}
